import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { customStylesSelect } from "../Class/Class_Etc"
//Add By PRATAN : 2023-08-09 (Ref : Select_ProjectByTimeSheet)
// การใช้งาน props
// API_URL                = url API  โดย นำมาจากค่า configData.API_URL

// pro_status(string)     = "-1" : ดึงมาทั้งทุกหมด
//                        =  "0" : ดึงเฉพาะสถานะที่ยกเลิก
//                        =  "1" : ดึงมาเฉพาะคนที่ยังใช้งาน

// staff_status(string)   = "-1" : ดึงมาทั้งทุกหมด
//                        =  "0" : ดึงเฉพาะสถานะที่ยกเลิก
//                        =  "1" : ดึงมาเฉพาะคนที่ยังใช้งาน

// selectismulti          = true , false เพื่อบอกว่า เลือกได้ ครั้งละหลายรายการหรือไม่

// SelectTextDefault      = ค่าแรกสุดที่เป็น value -1 จะให้ชื่อว่าอะไร
//                        = โดย selectismulti = true เท่านั้น ถึงนำไปใช้
//                        = ถ้า  selectismulti = false เราจะไม่นำไปใช้

// resetSelect            = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก Reset

// onChangevalue          = ส่ง function เข้ามา เพื่อตอน เลือกค่าใน select จะได้ return event กลับไปยัง function ข้างนอก
//                        = เพื่อให้ function ข้างนอกนั้น เอาไป set ค่าใช้งานอีกที
//                        = โดยจะเป็น function ที่ รับ parameter 1 ตัวเท่านั้น

// iscloseMenuOnSelect    = true , false เพื่อบอกว่า  เมื่อมีการเลือก ข้อมูล select แล้ว ตัวกล่อง select จะถูกปิด หรือ เปิดค้างไว้  
//                        = true   เมื่อเลือกก็จะปิด select เหมาะสำหรับ selectismulti = false  
//                        = false  เมื่อเลือกก็จะเปิด select ค้างไว้ เหมาะสำหรับ selectismulti = true

// refid                  = การอ้างอิง

// Update By AU : 2024-05-14
// แก้ไขโดยเพิ่ม parameter cus_id
// Valueshow              = ส่งมาเป็น value เลย  เช่น  1 หรือ 1,2,5  หรือ  2,4,7,2  ประมาณนี้
// setvalueSelect         = ส่ง ตัวแปร useState เข้ามา เพราะ ถ้า  ตัวแปร useState นั้นถูกเปลี่ยนแปลงค่าเมื่อไหร่ จะทำให้ ค่า select ถูก set ตาม Valueshow

// hd_cus_id              = ชื่อ id ของ hidden เพื่อที่จะ get ค่าส่งไป
// BindProjectBycusid     = useState int  เป็นตัวบอกว่า ถ้า useState นี้ทำงาน จะให้ Bind List Project ใหม่ ตาม hd_cus_id
// Bindendfunction        = เป็น function เพื่อให้ Return กลับไปบอกหน้าหลักว่า Bind list เสร็จแล้ว

function Select_ProjectByApprove(props) {
  const {
    API_URL,
    pro_status,
    staff_status,
    selectismulti,
    SelectTextDefault,
    resetSelect,
    onChangevalue,
    iscloseMenuOnSelect,
    refid,
    Valueshow,
    setvalueSelect,
    hd_cus_id,
    BindProjectBycusid,
    Bindendfunction
  } = props;

  const [isFirst, setIsFirst] = useState(true);
  const [listData, setListData] = useState([]);
  const [selectValue, setSelectValue] = useState([]);
  const animatedComponents = makeAnimated();

  useEffect(() => {
    if (isFirst) {
      BindDDL_Project("-1");
      setIsFirst(false);
    }
    // eslint-disable-next-line
  }, [isFirst]);

  useEffect(() => {
    if (resetSelect) {
      setSelectValue([]);
      onChangevalue(null);
    }
    // eslint-disable-next-line
  }, [resetSelect]);

  useEffect(() => {
    if (setvalueSelect) {
      try
      {
        if (Valueshow.length > 0){
          let arr = [];
          let arrValueshow = Valueshow.split(",");
          for (let i = 0 ; i < arrValueshow.length; i++){
            listData.filter(e => parseInt(e.value) === parseInt(arrValueshow[i])).map((en) => {
              return arr.push({
                value: en.value,
                label: en.label,
              });
            });
          }
          setSelectValue(arr);
          onChangevalue(arr)
        }
      }
      catch{
      }
    }
    // eslint-disable-next-line
  }, [setvalueSelect]);

  useEffect(() => {
    if (BindProjectBycusid) {
      if (isFirst === false && BindProjectBycusid > 0){
        let cus_id = document.getElementById(hd_cus_id).value
        BindDDL_Project(cus_id , function(){
          setSelectValue([]);
          onChangevalue(null);
          Bindendfunction();
        });
      }
    }
    // eslint-disable-next-line
  }, [BindProjectBycusid , isFirst]);

  async function BindDDL_Project(cus_id , _callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_status: pro_status,
        staff_status: staff_status,
        cus_id: cus_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        API_URL + "Project_GetDDLByApprove",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (selectismulti) {
            setListData(json.data);
          } else {
            setListData([
              {
                rowindex: 0,
                value: -1,
                label: SelectTextDefault,
                pro_id: -1,
                pro_name: SelectTextDefault,
              },
              ...json.data,
            ]);
          }
        } else {
          setListData([]);
        }
        if (_callback != null) {
          _callback();
        }
      }
      else {
        setListData([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListData([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  function onChange_select(e) {
    setSelectValue(e);
    onChangevalue(e);
  }

  return (
    <>
      <Select
        ref={refid}
        closeMenuOnSelect={iscloseMenuOnSelect}
        components={animatedComponents}
        placeholder={SelectTextDefault}
        isMulti={selectismulti}
        options={listData}
        value={selectValue}
        isClearable={true}
        menuPortalTarget={document.body}
        onChange={(e) => onChange_select(e)}
         //styles={{
          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        //}}
        styles={customStylesSelect}
      />
    </>
  );
}

export default Select_ProjectByApprove;
